import React from 'react'
import { Desc } from '../../../Components/Typography/Text.styles'

export const Bio: React.FC<React.PropsWithChildren<{ text?: string | null }>> = ({
  text,
}) => {
  if (text === null || text === undefined) {
    return null
  }
  return <Desc>{text}</Desc>
}
